import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { StatusIndicator } from "@design-system/StatusIndicator/StatusIndicator";
import type { McpConnectionRow } from "../mcpConnectionsViewConfig";
import { connectionStatus } from "../mcpConnectionHelpers";
import styles from "../McpCliSettings.module.scss";

export const ConnectionStatusCell = memo(
    ({ row }: CellContext<ViewTableFeatures, McpConnectionRow, unknown>) => (
        <ViewTableCell>
            <StatusIndicator
                appearance="solid"
                variant={row.original.revokedAt !== null ? "gray" : "blue"}
                label={connectionStatus(row.original)}
                showText
                className={styles.connectionStatus}
                textClassName={styles.connectionStatusText}
            />
        </ViewTableCell>
    ),
);
